import { Box, Loader, Select, Text } from "@mantine/core"
import { useDebouncedCallback } from "@mantine/hooks"
import { useEffect, useState } from "react"
import { getAllSupplierList } from "../../../services/supplier"

const InputSupplierActionBanner = ({ dataSupplierIds, onChange, isError }) => {
  const [supplierId, setSupplierId] = useState(null)

  const [supplierList, setSupplierList] = useState([])
  const [loadingSupplier, setLoadingSupplier] = useState(true)
  const [searchSupplier, setSearchSupplier] = useState('')

  const handleGetListSupplier = useDebouncedCallback(async (supplierId) => {
    setLoadingSupplier(true)
    const parameter = {
      'filter[id][is]': supplierId,
      'filter[name][like]': searchSupplier,
      'page[num]': 1,
      'page[limit]': 10, // bad habbit
      'fields[supplier]': 'name'
    }

    try {
      const response = await getAllSupplierList(parameter)
      const dataSuppliers = response.data
      const remapDataSuppliers = dataSuppliers.map((val) => {
        return {
          value: `${val.attributes.id}`,
          label: val.attributes.name
        }
      })
      setSupplierList(remapDataSuppliers)
    } catch (error) {
      console.log(error)
    } finally {
      setLoadingSupplier(false)
    }
  }, 300)

  useEffect(() => {
    const initialSupplierId = dataSupplierIds[0] || null
    setSupplierId(initialSupplierId)

    if (initialSupplierId) {
      handleGetListSupplier(initialSupplierId)
    }

    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    handleGetListSupplier()
    // eslint-disable-next-line
  }, [searchSupplier])


  const handleChage = (val) => {
    setSupplierId(val)
    onChange(val)
  }

  const loadingDataTemplate = () => {
    return (
      <Box ta='center' my={12}>
        <Loader size={16} />
        <Text c='gray.6' fz={11}>Loading Data</Text>
      </Box>
    )
  }

  return (
    <Select
      name='input_supplier_banner'
      label='Supplier'
      value={supplierId}
      data={supplierList}
      onChange={(val) => handleChage(val)}
      size='xs'
      searchable
      searchValue={searchSupplier}
      onSearchChange={setSearchSupplier}
      nothingFoundMessage={!loadingSupplier ? supplierList.length > 0 ? '' : 'No Supplier Found' : loadingDataTemplate()}
      clearable
      error={isError && 'Supplier is Required'}
    />
  )
}

export default InputSupplierActionBanner